import { ReactNode } from 'react';

import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Collapse, Stack, Typography } from '@mui/material';

interface SectionProps {
  title: string;
  isCollapsed: boolean;
  toggleIsCollapsed: () => void;
  children: ReactNode;
}

export const Section = ({
  title,
  isCollapsed,
  toggleIsCollapsed,
  children,
}: SectionProps) => {
  return (
    <Box>
      <Stack
        onClick={toggleIsCollapsed}
        direction={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Typography variant="subtitle1" fontWeight="500">
          {title}
        </Typography>
        {isCollapsed ? <ExpandLess /> : <ExpandMore />}
      </Stack>
      <Collapse in={isCollapsed} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </Box>
  );
};
